import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, Chip, darken, lighten, Typography } from '@mui/material';

export const CONTAINER_HEIGHT = '14rem';

interface MembershipColorProps {
  membershipColor?: string;
}

export const Container = styled.div<MembershipColorProps>`
  display: flex;
  max-width: 36rem;
  height: ${CONTAINER_HEIGHT};
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
  background-image: linear-gradient(
    to bottom right,
    ${p => p.membershipColor},
    ${p => darken(p.membershipColor!, 0.2)}
  );
  color: ${p => p.theme.palette.getContrastText(p.membershipColor!)};
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
`;

export const MembershipLogo = styled(Avatar)<MembershipColorProps>`
  ${p =>
    p.membershipColor &&
    css`
      background-color: ${darken(p.membershipColor!, 0.25)};
      color: ${p.theme.palette.getContrastText(p.membershipColor)};
    `}

  img {
    object-fit: contain;
  }
`;

MembershipLogo.defaultProps = {
  variant: 'rounded',
};

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Title = styled(Typography)`
  font-weight: 600;
  font-size: 1.2rem;
`;

export const MemberName = styled(Typography)`
  font-weight: bold;
`;

export const MemberPoints = styled(Typography)``;

MemberPoints.defaultProps = {
  variant: 'caption',
};

export const MemberSince = styled(Typography)<MembershipColorProps>`
  ${p =>
    p.membershipColor &&
    css`
      color: ${lighten(p.membershipColor!, 0.7)};
    `}
`;

export const MembershipCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const MembershipStatus = styled(Chip)<MembershipColorProps>`
  ${p =>
    p.membershipColor &&
    css`
      background-color: ${lighten(p.membershipColor!, 0.15)};
      color: ${p.theme.palette.getContrastText(p.membershipColor)};
    `}
`;
